module.exports = __webpack_public_path__ + "img/58.92564a7e.jpg";